import ValidationRule from './validation.rule.js';

class EmailIsAvailableRule extends ValidationRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.email = document.querySelector(`#${this.getFormID()} input[type="email"]`);

        if (this.email === null) {
            console.log(`${this.getFormID()} has no input[type="email"] element. ${this.getRuleName()} can be applyied`);
            this.check = async () => true;
            return;
        }

        this.isAvailable = false;
        this.isActive = true;

        this.generateFeedback(this.email);

        this.email.addEventListener('input', () => {
            this.resetValidity(this.email);
        });

        this.email.addEventListener('blur', event => {
            // check if native HTML constraient are satisfied
            const isValid = this.email.checkValidity();

            if (this.isActive === true) {
                if (isValid === false) {
                    this.email.reportValidity();
                }

                else {
                    Promise.resolve(this.checkEmail());
                }

                this.isActive = false;
                this.email.blur();

                setTimeout(() => {
                   this.isActive = true;
                }, 1000);
            }

            else {
                this.email.setCustomValidity('');
                if (isValid) {
                    this.email.reportValidity();
                }
            }
        });
    }

    getRuleName() {
        return 'email-is-available';
    }

    clearValidity() {
        this.resetValidity(this.email)
    }
    refreshValidity(target) {
        if (
            this.isAvailable === false &&
            this.email.checkValidity() === true
        ) {
                this.invalidate(this.email);
        }
    }

    refreshFeedback() {
        this.refreshValidity();
    }

    verifyEmail() {
        return new Promise(resolve => {
            setTimeout(() => resolve(window.emailIsAvailable || false), 1000);
        });
    }

    async checkEmail() {
        const isAvailable = await this.verifyEmail(this.email.value);
        this.isAvailable = isAvailable === true;
        this.refreshValidity();
    }

    async check () {
        if (this.isAvailable === null) {
            await this.checkEmail();
            this.getForm().requestSubmit();
        }

        return this.isAvailable === true;
    }
}

export default EmailIsAvailableRule;
